import { createSlice } from '@reduxjs/toolkit'
import { User } from '../../lib/types/User'

type InitialState = {
  user: User | null
  isAuthenticated: boolean
}

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    user: null,
    isAuthenticated: false,
  } as InitialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload
    },
    setAuthenticated: (state, action) => {
      if (action.payload) {
        state.isAuthenticated = true
      } else {
        state.user = null
        state.isAuthenticated = false
      }
    },
  },
})

export const { setUser, setAuthenticated } = userSlice.actions

export default userSlice.reducer
